import { useEffect } from "react";

export default function useSEO({
  title,
  description,
  keywords,
  canonical,
  ogTitle,
  ogDescription,
  ogImage,
}) {
  useEffect(() => {
    // Title
    if (title) document.title = title;

    // Description
    updateMeta("description", description);

    // Keywords
    updateMeta("keywords", keywords);

    // Canonical
    if (canonical) {
      let link = document.querySelector("link[rel='canonical']");
      if (!link) {
        link = document.createElement("link");
        link.rel = "canonical";
        document.head.appendChild(link);
      }
      link.href = canonical;
    }

    // Open Graph Tags
    updateOG("og:title", ogTitle || title);
    updateOG("og:description", ogDescription || description);
    updateOG("og:image", ogImage);

  }, [
    title,
    description,
    keywords,
    canonical,
    ogTitle,
    ogDescription,
    ogImage,
  ]);
}

// ---- helper functions ----
function updateMeta(name, content) {
  if (!content) return;

  let meta = document.querySelector(`meta[name='${name}']`);
  if (!meta) {
    meta = document.createElement("meta");
    meta.setAttribute("name", name);
    document.head.appendChild(meta);
  }
  meta.setAttribute("content", content);
}

function updateOG(property, content) {
  if (!content) return;

  let meta = document.querySelector(`meta[property='${property}']`);
  if (!meta) {
    meta = document.createElement("meta");
    meta.setAttribute("property", property);
    document.head.appendChild(meta);
  }
  meta.setAttribute("content", content);
}
